import React, {useEffect, useState} from 'react'
import {Trans} from '@lingui/macro'
import {useDispatch, useSelector} from 'react-redux'
import {useInputChange} from 'hooks/useInputChange';
import {typePaginationDashboardObject} from '../DashboardContentTable/PaginationDashboard/PaginationDashboard';
import { IdRefundsState, typeRefundsFilters } from 'model/dashboardRefunds/dRefundsReducer';
import {
    dRefundsClearFiltersAC,
    dRefundsSetDataSagaAC, dRefundsSetDetailItemAC, dRefundsSetFiltersAC, dRefundsSetItemsForPageAC,
    dRefundsSetPageNumberAC
} from 'model/dashboardRefunds/dRefundsActionCreators';
import { ViewDataRefunds } from 'components/containers/dashboard/dataRefunds/ViewComponent';





// Type
export type typeRefunds = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export type typeDataRefundsRowActions = { title: JSX.Element, action: (id: string) => void }[]



// Component
export const DataRefunds: React.FC<typeRefunds> = ({variant, setSidebarOpen}) => {

    const dispatch = useDispatch()

    // DateFilter
    const [isActiveFilters, setIsActiveFilters] = useState(false)
    const [openFilterBar, setOpenFilterBar] = useState(false)
    const filters = useSelector((state: { dRefunds: IdRefundsState }) => state.dRefunds.filters)

    // Pagination
    const pagination: typePaginationDashboardObject = {
        paginationObject: useSelector((state: {dRefunds: IdRefundsState}) => state.dRefunds.pagination),
        onGoToPage: (id) => dispatch(dRefundsSetPageNumberAC(id)),
        onSelectItems: (itemsPerPage) => dispatch(dRefundsSetItemsForPageAC(itemsPerPage))

    }


    // Did mount & Did unmount
    useEffect(() => {

        return () => {
            dispatch(dRefundsClearFiltersAC())
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {

        dispatch(dRefundsSetDataSagaAC(
            filters,
            {
                page: pagination.paginationObject.pageNumber,
                size: pagination.paginationObject.itemsPerPage!
            }))
        // eslint-disable-next-line
    }, [
        filters,
        pagination.paginationObject.pageNumber,pagination.paginationObject.itemsPerPage
    ])

    // Search panel

    const searchStoreName = useSelector((state: { dRefunds: IdRefundsState }) => state.dRefunds.filters?.fmId)

    const {value: searchValue, setValue: setSearchValue, changeValueHandler: onChangeSearchValue} = useInputChange(searchStoreName || '')
    const onClearSearch = () => {
        dispatch(dRefundsSetFiltersAC({
            fmId: null
        }))

        setSearchValue('')
    }
    const onEnterSearch = () => {

        const filters: typeRefundsFilters = {
                fmId: searchValue.trim()
        }
        dispatch(dRefundsSetFiltersAC(filters))

    }


    // Popup Print
    const [openPopupPrint, setOpenPopupPrint] = useState(false)

    // Popup details
    const [openPopupDetails, setOpenPopupDetails] = useState(false)


    // Current item
    const currentItem = useSelector((state: { dRefunds: IdRefundsState }) => state.dRefunds.detailItem)


    // Make table item actions
    const rowsActions: typeDataRefundsRowActions = [

        {
            title: <Trans>Print</Trans>,
            action: (id: string) => {
                dispatch(dRefundsSetDetailItemAC(id))
                setOpenPopupPrint(true)
            }
        },
    ]



    // Print dialog actions
    const cancelPrint = () => {
        setOpenPopupPrint(false)
    }
    const printHandler = () => {
        setOpenPopupPrint(false)
    }

    return (
        <ViewDataRefunds

            variant={variant}
            setSidebarOpen={setSidebarOpen}

            openFilterBar={openFilterBar}
            setOpenFilterBar={setOpenFilterBar}

            openPopupDetails={openPopupDetails}
            setOpenPopupDetails={setOpenPopupDetails}

            openPopupPrint={openPopupPrint}
            setOpenPopupPrint={setOpenPopupPrint}
            onCancelPrint={cancelPrint}
            onPrintSubmitClick={printHandler}

            searchValue={searchValue}
            onChangeSearchValue={onChangeSearchValue}
            onEnterSearch={onEnterSearch}
            onClearSearch={onClearSearch}

            rowsActions={rowsActions}

            currentItem={currentItem}
            pagination = {pagination}
            isActiveFilters={isActiveFilters}
            setIsActiveFilters={setIsActiveFilters}
        />

    )
}
